module.exports = __webpack_public_path__ + "082f76e405d7f27205bd6f78112830a8.svg";